import React from "react";
import { InfluencerGrowth } from "../../../../Task/tabs/ProfileDataTab/single/InfluencerGrowth";

export const renderCreatorGrowth = (label, data, layout, GridBoxComponent) => {
  const {
    followersStatisticsData,
    user_data: { followers },
  } = data;

  const height = layout?.find((item) => item.i === label)?.h;

  return (
    <GridBoxComponent key={label} id={label}>
      <InfluencerGrowth
        followersStatisticsData={followersStatisticsData}
        followers={followers}
        height={height}
      />
    </GridBoxComponent>
  );
};
